import React, { useState, useRef, useContext, useEffect } from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import "./main.scss";
import { motion, useViewportScroll } from "framer-motion";
import { CartContext } from "../context/CartContext";
import ProgressBarTop from "./ProgressBarTop";
export default function Nav(props) {
  // const [isOpen, setIsOpen] = useState(false);
  let isOpen = false;
  const button = useRef();
  const nav = useRef();
  const home = props.home;
  const about = props.about;
  const contact = props.contact;
  const cart = props.cart;
  const { cartAmount, sum } = useContext(CartContext);
  const [bg, setBg] = useState("none");
  const [y, setY] = useState();
  const hidden = home !== "nav-active" ? "#051922" : "rgba(0,0,0,0)";
  const footer = props.height;
  useEffect(() => {
    function updateScroll() {
      const y = window.scrollY;
      setY(y);
    }
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", updateScroll);
    }
  }, [y]);

  function dropdownMenu(e) {
    if (typeof window !== "undefined") {
      e.preventDefault();
      if (isOpen === false) {
        document.querySelector(".nav-list").classList.add("menu-active");
        document.querySelector(".menu").classList.add("close-icon");
        isOpen = true;
      } else {
        document.querySelector(".nav-list").classList.remove("menu-active");
        document.querySelector(".menu").classList.remove("close-icon");
        isOpen = false;
      }
    } else {
      console.log("Rendering on server");
    }
  }
  if (typeof window !== "undefined") {
    document.addEventListener("click", function (e) {
      const clickInside =
        document.querySelector(".menu") !== null
          ? document.querySelector(".menu").contains(e.target)
          : false;
      if (!clickInside) {
        document.querySelector(".nav-list").classList.remove("menu-active");
        document.querySelector(".menu").classList.remove("close-icon");
        isOpen = false;
      }
    });
  } else {
    console.log("Rendering on server");
  }

  return (
    <>
      <ProgressBarTop bg={y > 0 ? "visible" : "hidden"} />
      <motion.nav
        className="nav"
        style={{ backgroundColor: y > 0 ? "#051922" : hidden }}
      >
        <div className="container1">
          <motion.div className="logo" style={{ backgroundColor: bg }}>
            <Link to="/">
              <StaticImage
                src="../images/logo.png"
                alt="logo"
                width={150}
                height={"auto"}
              />
            </Link>
            <button ref={button} onClick={dropdownMenu} className="menu">
              <span></span>
              <span></span>
              <span></span>
            </button>
          </motion.div>
          <div className="nav-list-container">
            <ul ref={nav} className="nav-list">
              <li>
                <Link to="/" className={home}>
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className={about}>
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className={contact}>
                  Contact
                </Link>
              </li>

              <li className="cart-link">
                <Link to="/cart">
                  <div className={`amount-items ${cart}`}>
                    <span>{cartAmount !== 0 ? cartAmount : false}</span>
                  </div>
                </Link>
                <p>{`Total: ${sum}$`}</p>
              </li>
            </ul>
          </div>
        </div>
      </motion.nav>
    </>
  );
}
